import React from 'react'
import { EmailConsumer } from '../../../../context/Email'
import { LoggedOffHeaderLogin } from './LoggedOffHeaderLogin'
import { LoggedInHeaderLogin } from './LoggedInHeaderLogin'
import { isResponseFull } from '../../Email/EmailUtils'
import { LoadingBubble } from '../LoadingBubble'

export const HeaderLogin = ({
  emailWidget,
  userMenuWidget,
  ecoIdentity,
  leaderboardHeight,
  loginModalElement,
  userMenuElement,
  headerHeight,
  domain,
  activeDynamicLayout
}) => {
  return (
    <EmailConsumer>
      {({ inbox, userInfo, isLoading }) => {
        if (isLoading) {
          return <LoadingBubble />
        }

        const isLoggedIn = isResponseFull(inbox)
        if (isLoggedIn) {
          return (
            <LoggedInHeaderLogin
              emailWidget={emailWidget}
              userMenuWidget={userMenuWidget}
              ecoIdentity={ecoIdentity}
              inbox={inbox}
              userInfo={userInfo}
              leaderboardHeight={leaderboardHeight}
              userMenuElement={userMenuElement}
              headerHeight={headerHeight}
              domain={domain}
              layout={activeDynamicLayout}
            />
          )
        }

        return (
          <LoggedOffHeaderLogin
            inbox={inbox}
            ecoIdentity={ecoIdentity}
            leaderboardHeight={leaderboardHeight}
            loginModalElement={loginModalElement}
            headerHeight={headerHeight}
            domain={domain}
          />
        )
      }}
    </EmailConsumer>
  )
}
